import { getKeys } from "../../shared/utils/object";
import { type InsightsMetricsMap, type StatsItem } from "../models";

export const combineIncompleteDateStats = (
    chartsMetrics: InsightsMetricsMap<StatsItem>,
    incompleteDateMetrics: InsightsMetricsMap<StatsItem>,
): InsightsMetricsMap<StatsItem> => {
    const result = { ...chartsMetrics };

    for (const key of getKeys(result)) {
        const value = result[key];
        if (value) {
            result[key] = { ...value, stats: [...value.stats, ...(incompleteDateMetrics[key]?.stats ?? [])] };
        }
    }

    return result;
};
